import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IUpdateCampaignBidRequest, IUpdateCampaignBidResponse } from "../../features/Campaigns/interface";
import { useAuth } from "../helper/useAuth";

export const useUpdateCampaignBid = () => {
  const queryClient = useQueryClient();
  const { selectedIntegration } = useAuth();

  return useMutation<IUpdateCampaignBidResponse, Error, IUpdateCampaignBidRequest>({
    mutationFn: async (params: IUpdateCampaignBidRequest) => {
      const response = await httpService.post<IUpdateCampaignBidResponse, IUpdateCampaignBidRequest>(
        API_CONFIG.path.updateCampaignBid,
        params,
        { tracking_id: selectedIntegration?.value as string },
      );
      return response;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["google-ads-campaign-detail", String(variables.campaign_id)],
      });
      queryClient.invalidateQueries({
        queryKey: ["campaignBidHistory", "campaigns"],
      });
    },
  });
};
